const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.my_token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  tagList: state => state.settings.tagList,
  tag: state => state.settings.tag,
  isFullScren: state => state.settings.isFullScren,
  lockPasswd: state => state.settings.lockPasswd,
  isLock: state => state.settings.isLock,
  themeName: state => state.settings.themeName,
  userInfo: state => state.user.userInfo,
  language: state => state.common.language,
  website: state => state.common.website,
  userRole: state => state.user.userRole,
  colorName: state => state.common.colorName,
  isShade: state => state.common.isShade,
  isCollapse: state => state.common.isCollapse,
  keyCollapse: (state, getters) => getters.screen > 1 ? getters.isCollapse : false,
  screen: state => state.common.screen,
  isMenu: state => state.common.isMenu,
  tagWel: state => state.tags.tagWel,
  roles: state => state.user.roles,
  permission: state => state.user.permission,
  menu: state => state.user.menu,
  menuId: state => state.user.menuId,
  menuAll: state => state.user.menuAll,
  logsList: state => state.logs.logsList,
  logsLen: state => state.logs.logsList.length || 0,
  logsFlag: (state, getters) => getters.logsLen === 0,
  flowRoutes: state => state.dict.flowRoutes,
  currentPage: (state) => state.backtolist.currentPage,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js